import axiosInstance from "./axiosInstance";

export interface EmployeeTypeApi {
  publicId: string;
  typeName: string;
  code: string;
  isITSMember: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string | null;
}

export interface EmployeeTypeFilters {
  typeName?: string;
  code?: string;
  isITSMember?: boolean;
  isActive?: boolean;
  pageNo?: number;
  pageSize?: number;
}

export interface EmployeeTypeSearchResponse {
  success: boolean;
  message: string;
  data: EmployeeTypeSearchPage;
  errors: unknown[];
}

export interface EmployeeTypeSearchPage {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  success: boolean;
  message: string;
  data: EmployeeTypeApi[];
  errors: unknown[];
}

export interface CreateEmployeeTypePayload {
  typeName: string;
  code: string;
  isITSMember: boolean;
  isActive: boolean;
}

export interface CreateEmployeeTypeResponse {
  success: boolean;
  message: string;
  data: string;
  errors: unknown[];
}

export interface UpdateEmployeeTypeResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: unknown[];
}

export interface DeleteEmployeeTypeResponse {
  success: boolean;
  message: string;
  data: boolean;
  errors: unknown[];
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getEmployeeTypes = async (
  filters: EmployeeTypeFilters = {},
): Promise<EmployeeTypeSearchResponse> => {
  try {
    const response = await axiosInstance.get<EmployeeTypeSearchResponse>(
      "/hr/settings/employee-types/search",
      {
        params: {
          TypeName: filters.typeName || undefined,
          Code: filters.code || undefined,
          IsITSMember: filters.isITSMember ?? undefined,
          IsActive: filters.isActive ?? undefined,
          PageNumber: filters.pageNo ?? 1,
          PageSize: filters.pageSize ?? 20,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createEmployeeType = async (
  payload: CreateEmployeeTypePayload,
): Promise<CreateEmployeeTypeResponse> => {
  try {
    const response = await axiosInstance.post<CreateEmployeeTypeResponse>(
      "/hr/settings/employee-types",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateEmployeeType = async (
  publicId: string,
  payload: CreateEmployeeTypePayload,
): Promise<UpdateEmployeeTypeResponse> => {
  try {
    const response = await axiosInstance.put<UpdateEmployeeTypeResponse>(
      `/hr/settings/employee-types/${publicId}`,
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteEmployeeType = async (
  publicId: string,
): Promise<DeleteEmployeeTypeResponse> => {
  try {
    const response = await axiosInstance.delete<DeleteEmployeeTypeResponse>(
      `/hr/settings/employee-types/${publicId}`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};